module.exports = __webpack_public_path__ + "static/media/5.19_preview.23f9289d.png";